import { useEffect, useState } from 'react';
import { useCommonUserProfile, useUserProfile } from '@hooks/user';

export default function useUseableMessage() {
  const [useableMessage, setUseableMessage] = useState<boolean>();
  const { userProfile: commonUserProfile } = useCommonUserProfile();
  const { userProfile } = useUserProfile();

  useEffect(() => {
    setUseableMessage(
      userProfile?.joinedCount > 0 || commonUserProfile?.subscribingCount > 0,
    );
  }, [userProfile, commonUserProfile]);

  return useableMessage;
}
